import { AISHA_API_BASE } from '@/constants';
import { ArtisanOrder } from './artisan-orders';

export interface ArtisanOrderComment {
  id: number;
  order: number;
  user_id: string;
  user_name: string;
  is_admin: boolean;
  content: string;
  image_url: string;
  created_at: string;
}

// ユーザーの注文一覧を取得
export const getUserArtisanOrders = async (userId: string): Promise<ArtisanOrder[]> => {
  const response = await fetch(`${AISHA_API_BASE}/artisan-orders/my/?user_id=${userId}`);
  const result = await response.json();
  if (result.success) return result.data;
  throw new Error(result.error || '注文一覧の取得に失敗しました');
};

// 注文のコメント一覧を取得
export const getOrderComments = async (orderId: number, userId?: string, isAdmin?: boolean): Promise<{ order: ArtisanOrder; comments: ArtisanOrderComment[] }> => {
  const params = new URLSearchParams();
  if (userId) params.append('user_id', userId);
  if (isAdmin) params.append('admin', '1');
  const qs = params.toString();
  const response = await fetch(`${AISHA_API_BASE}/artisan-orders/${orderId}/comments/${qs ? `?${qs}` : ''}`);
  const result = await response.json();
  if (result.success) return { order: result.order, comments: result.comments };
  throw new Error(result.error || 'コメント一覧の取得に失敗しました');
};

// コメント投稿
export const createOrderComment = async (
  orderId: number,
  data: { user_id: string; user_name: string; is_admin: boolean; content: string; image_url?: string }
): Promise<{ comment: ArtisanOrderComment; order: ArtisanOrder }> => {
  const response = await fetch(`${AISHA_API_BASE}/artisan-orders/${orderId}/comments/create/`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });
  const result = await response.json();
  if (result.success) return { comment: result.comment, order: result.order };
  throw new Error(result.error || 'コメントの投稿に失敗しました');
};

// 注文を確定（製造中に変更）
export const confirmOrder = async (orderId: number, estimatedDeliveryDate?: string): Promise<ArtisanOrder> => {
  const response = await fetch(`${AISHA_API_BASE}/artisan-orders/${orderId}/confirm/`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ estimated_delivery_date: estimatedDeliveryDate }),
  });
  const result = await response.json();
  if (result.success) return result.data;
  throw new Error(result.error || '注文の確定に失敗しました');
};

// 注文をキャンセル
export const cancelOrder = async (orderId: number): Promise<ArtisanOrder> => {
  const response = await fetch(`${AISHA_API_BASE}/artisan-orders/${orderId}/cancel/`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
  });
  const result = await response.json();
  if (result.success) return result.data;
  throw new Error(result.error || '注文のキャンセルに失敗しました');
};

// 到着評価投稿
export const submitReview = async (
  orderId: number,
  data: { review_rating: number; review_comment: string; review_image_url: string }
): Promise<ArtisanOrder> => {
  const response = await fetch(`${AISHA_API_BASE}/artisan-orders/${orderId}/review/`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });
  const result = await response.json();
  if (result.success) return result.data;
  throw new Error(result.error || '評価の投稿に失敗しました');
};
